export const smartSchedulesExtensionTooltipMessage =
    "This feature is included in the 'Scheduler Smart Schedules' extension.";
export const smartFiltersExtensionTooltipMessage = "This feature is included in the 'Capacity Finder' extension.";
export const unassignedWorkExtensionTooltipMessage = "This feature is included in the 'Unassigned Work' extension.";
